import axios from 'axios';

// Use relative URL so the app works on ANY deployment domain
// (preview, production custom domain, etc.) without cross-origin issues.
// Falls back to env var only for non-browser contexts (tests, SSR).
const API_URL = typeof window !== 'undefined' ? '' : (process.env.REACT_APP_BACKEND_URL || '');

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth endpoints that should NEVER trigger the refresh/redirect interceptor
const AUTH_ENDPOINTS = ['/auth/me', '/auth/login', '/auth/register', '/auth/refresh', '/auth/logout', '/auth/google/session'];

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const requestPath = originalRequest?.url || '';

    // Skip retry logic for auth endpoints — let callers handle 401 directly
    const isAuthEndpoint = AUTH_ENDPOINTS.some(ep => requestPath.includes(ep));
    if (isAuthEndpoint) {
      return Promise.reject(error);
    }

    // For all other 401s, try a silent token refresh once
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        await api.post('/auth/refresh');
        return api(originalRequest);
      } catch {
        // Don't force-redirect — let ProtectedRoute handle navigation
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
